module.exports = __webpack_public_path__ + "img/10.2f099f8.jpg";